(ns frontend.test.filter.view
  (:require
   [frontend.test.filter.event :as event]
   [ui.page-components.filter-bar.view :as filter-bar]))

(defn view
  []
  [:div
   {:class "p-6"}
   [filter-bar/view
    {:component-id "test-1"
     :filter-paths event/test-fields}]
   [filter-bar/view
    {:component-id "test-2"
     :filter-paths event/test-fields}]])
